module.exports = __webpack_public_path__ + "img/zhenku3.01eb38a0.png";